import { Box } from '@bridebook/ui';
import styles from '@bridebook/ui/src/components/bbcommon/bullet-point-row/bullet-point.row.style';
import { IconApprove } from '@bridebook/ui/src/icons/dynamic';

interface IProps {
  text: string;
}

const BulletPointRow = ({ text }: IProps) => (
  <Box style={styles.itemWrap}>
    <Box style={styles.iconWrap}>
      <IconApprove width={16} color="indigoCrush" />
    </Box>
    <Box style={styles.text}>{text}</Box>
  </Box>
);

export default BulletPointRow;
